import { indexBy, prop, propOr, map, pathOr } from 'ramda';
import { compose } from 'recompose';

const stripHtmlTagsFrom = htmlStr => {
  const div = document.createElement('div');

  div.innerHTML = htmlStr;

  return div.textContent || div.innerText || '';
};

const NewsItem = ({ title, description, link, image }) => ({
  title,
  subtitle: stripHtmlTagsFrom(description),
  url: link,
  image,
});

const News = compose(
  map(NewsItem),
  pathOr([], ['latest_news', 'items']),
  indexBy(prop('type')),
  propOr([], 'data'),
);

export { News };
